const quarterValueToHuman = (quarterValue: string) => {
  let quarter = '';
  switch (quarterValue) {
    case 'quarter_1':
      quarter = '1º Trimestre';
      break;
    case 'quarter_2':
      quarter = '2º Trimestre';
      break;
    case 'quarter_3':
      quarter = '3º Trimestre';
      break;

    default:
      break;
  }

  return quarter;
};

export default quarterValueToHuman;
